import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { Router } from '@angular/router';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { BuyflowVesselSortType } from 'anchor-shared/lib/model/enum/buyflow-vessel-sort-type';
import { buildRouteEnding } from '../../../../core/pure-functions/navigation/buyflow-vessel-route-builder/buyflow-vessel-route-builder';
import { EnvironmentalMediaService } from '../../../../core/services/environmental-media.service';

@Component({
  selector: 'app-buyflow-vessel-list',
  templateUrl: './buyflow-vessel-list.component.html',
  styleUrls: ['./buyflow-vessel-list.component.scss'],
})
export class BuyflowVesselListComponent implements OnInit, OnDestroy {
  @Input() vessels: Partial<Vessel[]>;
  @Input() sortOrderFieldName: BuyflowVesselSortType;
  @Input() classFitName: string;
  @Input() waterBodyId: number;

  placeholder: string;

  constructor(private router: Router, private waterBodyDAO: WaterBodyDAO) {}

  ngOnInit() {
    this.placeholder = 'https://via.placeholder.com/640x360';
  }

  ngOnDestroy(): void {}

  checkAvailability(vessel: Vessel): void {
    window.open(
      'vessels/yacht-and-boat-rentals/' + buildRouteEnding(vessel),
      '_blank',
    );
  }

  getClassForFit(): string {
    return this.classFitName;
  }

  getMemberPrice(price: number): number {
    return price - price * 0.1;
  }
}
